import React, { ReactElement } from "react";
import { Route, Routes } from "react-router-dom";
import useRouting from "../../contexts/Routing";
import AgentV3 from "../agent-v3/Agent";
import Agent from "./Agent";

import { SelectionStateProvider } from "../../contexts/selection-state/SelectionStateContext";
import { useTheme } from "../../contexts/Theme";

export default function AgentRoute() : ReactElement {
    const { Paths } = useRouting();
    const theme = useTheme();

    return !theme.isV3 ? (
        <SelectionStateProvider>
            <Routes>
                <Route path="/" element={<Agent />} />
                <Route index element={<Agent />} />
                <Route path={Paths.AGENT_CHAT.replace(`${Paths.AGENT}/`, "")} element={<Agent />} />
            </Routes>
        </SelectionStateProvider>
    ) : (

        <Routes>
            <Route path="/" element={<AgentV3 />} />
            <Route index element={<AgentV3 />} />
            <Route path={Paths.AGENT_CHAT.replace(`${Paths.AGENT}/`, "")} element={<AgentV3 />} />
        </Routes>

    );
}

AgentRoute.defaultProps = {
    component: undefined,
    children: undefined,
    exact: true,
};
